<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAuthenticated_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M3.584 12.209Q5.168 14.387 7.6 15q2.432-.613 4.016-2.791Q13.2 10.029 13.2 7.37V3.1L7.6 1 2 3.1v4.27q0 2.66 1.584 4.839m6.332-6.091a.402.402 0 1 1 .569.569L7.289 9.882a.4.4 0 0 1-.57 0L5.119 8.28a.402.402 0 1 1 .569-.569L7.004 9.03z"
        clip-rule="evenodd"
    />
</svg>
